import React, { useEffect, useState } from 'react'
import iconBack from 'assets/images/eventBunpimay/iconBack.png'
import iconDetail from 'assets/images/eventBunpimay/iconDetail.png'
import iconWaterGun from 'assets/images/eventBunpimay/iconGunWater.png'
import { useTranslation } from 'react-i18next'

import iconMenuHome from 'assets/images/eventBunpimay/iconMenuHome.png'
import iconMenuPrize from 'assets/images/eventBunpimay/iconMenuPrize.png'
import iconMenuRank from 'assets/images/eventBunpimay/iconMenuRank.png'
import iconMenuHomeActive from 'assets/images/eventBunpimay/iconMenuHomeActive.png'
import iconMenuPrizeActive from 'assets/images/eventBunpimay/iconMenuPrizeActive.png'
import iconMenuRankActive from 'assets/images/eventBunpimay/iconMenuRankActive.png'
import EventBunpimayHome from './components/EventBunpimayHome'
import EventBunpimayPairing from './components/EventBunpimayPairing'
import EventBunpimayPrize from './components/EventBunpimayPrize'
import EventBunpimayRank from './components/EventBunpimayRank'
import EventBunpimayDetail from './components/EventBunpimayDetail'
import { getItemsEventBunpimayQuery } from 'dataLayer/game'
import { useQuery } from 'react-query'
import { useLocation } from 'react-router-dom'
function EventBunpimay() {
	const { t } = useTranslation()
	const [tabActive, setTabActive] = useState('HOME')
	const location = useLocation()
	const {
		data,
		isLoading,
		refetch
	} = useQuery(getItemsEventBunpimayQuery())
	useEffect(() => {
		if (location && location.state && location.state.rank && location.state.rank === 'rank') {
			setTabActive('RANK')
		}
	}, [location])
	const listMenu = [
		{
			id: 1,
			title: t('event.bunpimay.homepage.home'),
			icon: iconMenuHome,
			iconActive: iconMenuHomeActive,
			tabActive: 'HOME',
		},
		{
			id: 2,
			title: t('event.bunpimay.homepage.prize'),
			icon: iconMenuPrize,
			iconActive: iconMenuPrizeActive,
			tabActive: 'PRIZE',
		},
		{
			id: 3,
			title: t('event.bunpimay.homepage.rank'),
			icon: iconMenuRank,
			iconActive: iconMenuRankActive,
			tabActive: 'RANK',
		},
	]
	return (
		<div className="container-event-bunpimay">
			<div className="container-event-bunpimay-header">
				<div className="container-event-bunpimay-header-action">
					{tabActive !== "HOME" ? <img onClick={() => setTabActive("HOME")} draggable="false" className="icon-action" src={iconBack} /> : null}
					<img onClick={() => setTabActive("DETAIL")} draggable="false" className="icon-action" src={iconDetail} />
				</div>
				<div className="container-event-bunpimay-header-watergun">
					<img draggable="false" className="icon-water-gun" src={iconWaterGun} />
					<div className="number">{data && data.waterGuns ? data.waterGuns : 0}</div>
				</div>
			</div>

			<div className={`container-event-bunpimay-menu ${tabActive !== "HOME" ? "menu-phone-row" : ""}`}>
				{listMenu.map(item => (
					<div
						className="container-event-bunpimay-menu-item"
						key={`item-menu-${item.id}`}
						onClick={() => setTabActive(item.tabActive)}
					>
						<img
							className="icon-menu" draggable="false"
							src={item.tabActive === tabActive ? item.iconActive : item.icon}
						/>
						<span className='menu-title'>{item.title}</span>
					</div>
				))}
			</div>

			<div className="container-event-bunpimay-box-content">
				{tabActive === "HOME" ? <EventBunpimayHome setTabActive={setTabActive} /> : null}
				{tabActive === "COLLECT" ? <EventBunpimayPairing refetchApi={refetch} dataBunpimay={data} /> : null}
				{tabActive === "PRIZE" ? <EventBunpimayPrize /> : null}
				{tabActive === "RANK" ? <EventBunpimayRank /> : null}
				{tabActive === "DETAIL" ? <EventBunpimayDetail /> : null}
			</div>
		</div>
	)
}

export default EventBunpimay
